{
  "dashboard": {
    "exportPDF": "Export to PDF",
    "yourFacilities": "Your Facilities",
    "companyPageLink": "Go to Company page",
    "kwhConsumed": "kWh Consumed",
    "energyConsumption": "Energy Consumption Used For Reporting",
    "mtCo2eDisplaced": "MT CO2e Displaced",
    "equalToCreditsGeneratedToDate": "Equal To Credits Generated To Date",
    "totalNetRevenueToDate": "Total Net Revenue To Date",
    "valueOfCreditsTransacted": "Value Of Credits Transacted",
    "avgCostPerKwh": "Avg. $/kWh",
    "enrolledVehiclesAndEquipment": "Enrolled Vehicles & Equipment",
    "totalNumberOfAssetsProducingCredits": "Total Number of Assets Producing Credits",
    "daysToNextCreditMinting": "Days To Next Credit Minting",
    "periodIncentiveRevenue": "Period Incentive Revenue",
    "cumulativeEnrollmentTrends": "Cumulative Enrollment Trends",
    "revenueBreakdown": "Revenue Breakdown",
    "byEquipmentType": "By Equipment Type",
    "byProgram": "By Program",
    "equipmentTypeByFacility": "Equipment Type By Facility",
    "currentFacilityLocations": "Current Facility Locations",
    "percentRevenueByEquipmenttype": "Percent Revenue By Equipment Type",
    "percentRevenueByProgram": "Percent Revenue By Program"
  }
}
